import { connect, MapStateToProps } from 'react-redux'
import { Props } from './PrStringInvocationModal'
import prStringStatusDataSelector from '../../redux/selectors/prStringStatusDataSelector'
import prStringRequestIsPendingSelector from '../../redux/selectors/pending-request/prStringRequestIsPendingSelector'
import { loadConfigurationByPrString } from '../../redux/actions/app/prString.actions'
import { resetPrStringStatusState } from '../../redux/actions/app/prString.actions'

type StateProps = Pick<Props, 'prStringStatus' | 'isLoading'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    prStringStatus: prStringStatusDataSelector(state),
    isLoading: prStringRequestIsPendingSelector(state),
})

type DispatchProps = Pick<Props, 'loadConfigurationByPrString' | 'resetPrStringStatus'>

const mapDispatchToProps: DispatchProps = {
    loadConfigurationByPrString: loadConfigurationByPrString,
    resetPrStringStatus: resetPrStringStatusState,
}

export default connect(mapStateToProps, mapDispatchToProps)
